import { get } from 'axios'

// get
function getUserNotifications (BASE_URL, pToken, pUserID, pAmount='') {
    const URI = `${BASE_URL}/api/users/${pUserID}/notifications?amount=${pAmount}`
    const headers = { Authorization : `Bearer ${pToken}`}
    return get(URI, { headers })
}

export { getUserNotifications }